import { render, staticRenderFns } from "./WaterIcon.vue?vue&type=template&id=4c7aec91&scoped=true&lang=pug&"
import script from "./WaterIcon.vue?vue&type=script&lang=ts&"
export * from "./WaterIcon.vue?vue&type=script&lang=ts&"
import style0 from "./WaterIcon.vue?vue&type=style&index=0&id=4c7aec91&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7aec91",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VIcon})
